import React from "react"
import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { useTranslation } from "react-i18next"

import { useTheme } from "hooks"
import ProtectedLayout from "layouts/Protected"
import { ContactForm } from "./Partials"

import MailIcon from "components/Elements/Icons/Mail"
import { isFrenchLanguage } from "utils/i18n"
import { DEFAULT_SIZE } from "utils/icons"

export const ContactPage = () => {
	const { t } = useTranslation()
	const { currentTheme } = useTheme()

	const phoneNumber = isFrenchLanguage() ? currentTheme.phone : currentTheme.internationalphone

	return (
		<ProtectedLayout className="py-5">
			<div className="l-container">
				<div
					className={clsx("c-section-title mb-7", {
						"px-8": !isMobileOnly,
						"px-6": isMobileOnly,
					})}
				>
					<div className="c-section-title__content justify-between">
						<div className="flex items-center justify-start w-full">
							<MailIcon size={DEFAULT_SIZE} className={""} />
							<h1 className="c-section-title__title c-h2 text-primary ml-4">
								{t("title", { ns: "contact" })}
							</h1>
						</div>
					</div>
				</div>
				<div
					className={clsx({
						"px-8": !isMobileOnly,
						"px-6": isMobileOnly,
					})}
				>
					<ContactForm />
					<section className="c-card p-5 md:p-12">
						<h2 className="c-h2 font-semibold mb-7 uppercase">
							{t("urgence_title", { ns: "contact" })}
						</h2>
						<p>
							{t("urgence_description", { ns: "contact", phoneNumber: phoneNumber })}
						</p>
					</section>
				</div>
			</div>
		</ProtectedLayout>
	)
}
